import { Injectable } from '@angular/core';
import { Response, RequestOptions, Headers } from "@angular/http";

import "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import { AuthService } from "../../auth/auth.service";

import { iResponseInfo } from '../../../interfaces/shared/iResponseInfo';
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../../environments/environment";
import { PersonPhotoService } from './person-photo.service';
import { Subscription } from 'rxjs/Rx';

@Injectable()
export class PersonInfoService {

  personInfoChanged = new Subject();
  onPersonPhotoChanged: Subscription;
  searchingDriver = new Subject();

  // by access code
  searchingDriverByAccessCode = new Subject();
  personInfoChangedByAccessCode = new Subject();

  constructor(private authService: AuthService,
    private authHttp: AuthHttp,
    private personPhotoService: PersonPhotoService) { }

  private personInfo: any;
  private personInfoByAccessCode: any;

  selectedClientId: number = 0;

  private responseInfo: iResponseInfo = new iResponseInfo();

  private errorMessage: string = null;
  hasErrors() {
    return this.errorMessage != null;
  }
  getErrorMessage() {
    return this.hasErrors() ? this.errorMessage : "";
  }

  loadPersonInfo(clientId: number, referenceNumber: string, dlNumber: string, languageId: number, ipAddress: string, emailAddressOfClientAccessing: string, appUserId: number) {
    this.searchingDriver.next(true);

    this.errorMessage = null;

    let postObj = {
      'clientId': clientId,
      'referenceNumber': referenceNumber,
      'dlNumber': dlNumber,
      'languageId': 1,
      'ipAddress': '',
      'emailAddressOfClientAccessing': this.authService.getUser().email,
      'appUserId': this.authService.getUser().appUserId
    };

    var qs = environment.apiPath + '/api/Enforcement/GetPersonInfo';

    return this.authHttp.post(qs, postObj)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            this.responseInfo = new iResponseInfo();

            this.personInfo = response;

            this.responseInfo.isSuccess = response.responseInfo.isSuccess;
            this.responseInfo.isWarning = response.responseInfo.isWarning;
            this.responseInfo.isError = response.responseInfo.isError;
            this.responseInfo.message = response.responseInfo.message;

            this.personInfoChanged.next();
            this.searchingDriver.next(false);

          },
          (error) => {
            this.errorMessage = error;
            this.personInfoChanged.next();
            this.searchingDriver.next(false);
          });
  }

  loadPersonInfoByAccessCode(referenceNumber: string, accessCode: string, languageId: number, ipAddress: string, emailAddressOfClientAccessing: string, appUserId: number) {
    this.searchingDriverByAccessCode.next(true);

    this.errorMessage = null;

    let postObj = {
      'referenceNumber': referenceNumber,
      'accessCode': accessCode,
      'languageId': 1,
      'ipAddress': '',
      'emailAddressOfClientAccessing': this.authService.getUser().email,
      'appUserId': this.authService.getUser().appUserId
    };

    var qs = environment.apiPath + '/api/Enforcement/GetPersonInfoByAccessCode';

    return this.authHttp.post(qs, postObj)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            this.responseInfo = new iResponseInfo();

            this.personInfoByAccessCode = response;

            this.responseInfo.isSuccess = response.responseInfo.isSuccess;
            this.responseInfo.isWarning = response.responseInfo.isWarning;
            this.responseInfo.isError = response.responseInfo.isError;
            this.responseInfo.message = response.responseInfo.message;

            this.personInfoChangedByAccessCode.next();
            this.searchingDriverByAccessCode.next(false);

          },
          (error) => {
            this.errorMessage = error;
            this.personInfoChangedByAccessCode.next();
            this.searchingDriverByAccessCode.next(false);
          });
  }

  getResponseInfo() {
    return this.personInfo == null ? new iResponseInfo() : this.responseInfo;
  }

  getResponseInfoByAccessCode() {
    return this.personInfoByAccessCode == null ? new iResponseInfo() : this.responseInfo;
  }

  clearPersonInfo(cleintId: number) {
    if (this.selectedClientId != cleintId) {
      this.selectedClientId = cleintId;
      this.personInfo = null;
      this.responseInfo = new iResponseInfo();
    }
  }

  clearPersonInfoByAccessCode(cleintId: number) {
    if (this.selectedClientId != cleintId) {
      this.selectedClientId = cleintId;
      this.personInfoByAccessCode = null;
      this.responseInfo = new iResponseInfo();
    }
  }

  getPersonVehicles() {
    return this.personInfo == null ? null : this.personInfo.vehicles;
  }

  getInfoReport() {
    return this.personInfo == null ? "" : this.personInfo.infoReport;
  }

  getPersonInfo() {
    return this.personInfo;
  }

  getPersonInfoByAccessCode() {
    return this.personInfoByAccessCode;
  }

  init() {
    this.personInfo = null;
    this.personInfoByAccessCode == null;
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/nonanon/person/person-info.service.ts